import {FC, useMemo} from 'react';
import {Drawer} from 'shared/ui/drawer';
import {
  NewEventBody,
  NewEventBorder,
  NewEventFooter,
  NewEventHead,
  NewEventRow,
  NewEventTitle,
  NewEventWrapper,
} from './styles';
import {Spacer} from 'shared/ui/spacer';
import {toRem} from 'shared/helpers';
import {CloseIcon} from 'shared/ui/icons';

import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import {TEvent} from 'entities/calendar';
import {format} from 'date-fns';
import {notifySelectItems} from 'shared/consts';
import {utcToUserDate} from 'features/calendar/helpers/dates.ts';

type CalendarDetailProps = {
  isOpen: boolean;
  isMobile?: boolean;
  event: TEvent;
  onClose: () => void;
  onEditClick: (event: TEvent) => void;
};
export const CalendarDetail: FC<CalendarDetailProps> = ({
  isOpen,
  isMobile,
  event,
  onClose,
  onEditClick,
}) => {
  const firstNotify = useMemo(() => {
    if (!event.notifyAt) {
      return 'Нет';
    }
    const notifDate = utcToUserDate(event.notifyAt);
    const start = utcToUserDate(event.startAt);

    const diff = notifDate.getTime() - start.getTime();

    const finded = notifySelectItems.find((el) => el.key === diff);
    if (!finded) return 'Нет';

    return finded.value;
  }, [event]);
  const secondNotify = useMemo(() => {
    if (!event.notifyAtRepeat) {
      return 'Нет';
    }
    const notifDate = utcToUserDate(event.notifyAtRepeat);
    const start = utcToUserDate(event.startAt);

    const diff = notifDate.getTime() - start.getTime();

    const finded = notifySelectItems.find((el) => el.key === diff);
    if (!finded) return 'Нет';

    return finded.value;
  }, [event]);

  return (
    <Drawer isOpen={isOpen} position="right" onClose={onClose}>
      <NewEventWrapper>
        <NewEventHead $isMobile={isMobile}>
          <Button
            iconPrefix={<CloseIcon />}
            variant={isMobile ? 'ghost' : 'secondary'}
            colorScheme="neutral"
            style={{alignSelf: 'flex-end', width: isMobile ? toRem(24) : toRem(36)}}
            size={isMobile ? 's' : 'm'}
            onClick={onClose}
          />
          <NewEventTitle>Детали события</NewEventTitle>
          {isMobile && <Spacer width={toRem(24)} height={toRem(24)} />}
        </NewEventHead>
        <NewEventBody>
          <NewEventRow>
            <span>Номера ульев</span>
            <span>{event.hives.map((el) => `№${el.number}`).join(', ')}</span>
          </NewEventRow>
          <NewEventRow $alignItems="flex-start">
            <span>Описание</span>
            <span>{event.description || '-'}</span>
          </NewEventRow>

          <NewEventBorder />

          <NewEventRow>
            <span>Начало</span>
            <span>{format(utcToUserDate(event.startAt), 'dd.MM.yyyy, HH:mm')}</span>
          </NewEventRow>
          <NewEventRow>
            <span>Окончание</span>
            <span>{format(utcToUserDate(event.endAt), 'dd.MM.yyyy, HH:mm')}</span>
          </NewEventRow>

          <NewEventBorder />

          <NewEventRow>
            <span>Напоминание</span>
            <span>{firstNotify}</span>
          </NewEventRow>
          <NewEventRow>
            <span>2-е напоминание</span>
            <span>{secondNotify}</span>
          </NewEventRow>
        </NewEventBody>
        <NewEventFooter>
          <Button type="button" label="Редактировать" onClick={() => onEditClick(event)} />
          <Button label="Закрыть" variant="ghost" colorScheme="neutral" onClick={onClose} />
        </NewEventFooter>
      </NewEventWrapper>
    </Drawer>
  );
};
